import {
  useCallback, useEffect, useMemo, useState,
} from 'react';

export default function useDropDown(defaultValue = {}, timer = false) {
  const [value, setValue] = useState(defaultValue);
  const [trigger, setTrigger] = useState(false);
  const onCLickHandler = useCallback(
    item => {
      setValue(item);
      setTrigger(false);
    },
    [setValue, setTrigger]
  );
  useEffect(() => {
    setValue(() => defaultValue);
  }, []);

  useEffect(() => {
    let timerId;
    if (timer) {
      timerId = setTimeout(() => setValue({}), 0);
    }
    return () => clearTimeout(timerId);
  }, [trigger, timer]);

  const dropDownValue = useMemo(() => value, [value, setValue]);
  return {
    onCLickHandler,
    value: dropDownValue,
    trigger,
    setTrigger,
    setValue,
  };
}
